(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["by_gender_category_ai"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('beez-category-collections')) {
  customElements.define('beez-category-collections', class extends HTMLElement {
    static selections = new Map();

    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.ready) return;
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.nav = this.querySelector('[data-tablist]');
        if (!this.nav || !this.tabs.length) return;
        this.ready = true;
        this.nav.setAttribute('role', 'tablist');
        this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });

        this.clickHandler = event => {
          const tab = event.target.closest('[data-tab]');
          if (tab && this.tabs.includes(tab)) this.select(tab.dataset.tab);
        };
        this.keyHandler = event => {
          const tab = event.target.closest('[data-tab]');
          const index = this.tabs.indexOf(tab);
          if (index < 0) return;
          let next;
          const rtl = getComputedStyle(this.nav).direction === 'rtl';
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next].dataset.tab);
          this.tabs[next].focus({ preventScroll: true });
        };
        this.editorHandler = event => {
          const id = event.detail && event.detail.blockId;
          if (id && this.panels.some(panel => panel.dataset.panel === id)) this.select(id);
        };
        this.nav.addEventListener('click', this.clickHandler);
        this.nav.addEventListener('keydown', this.keyHandler);
        this.addEventListener('shopify:block:select', this.editorHandler);

        const index = Math.max(0, Number(this.dataset.defaultTab || 1) - 1);
        const remembered = this.constructor.selections.get(this.id);
        const id = this.tabs.some(tab => tab.dataset.tab === remembered)
          ? remembered
          : (this.tabs[index] || this.tabs[0]).dataset.tab;
        this.select(id);
        this.setAttribute('data-enhanced', '');
      });
    }

    select(id) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
      this.constructor.selections.set(this.id, id);
    }

    disconnectedCallback() {
      if (!this.ready) return;
      this.nav.removeEventListener('click', this.clickHandler);
      this.nav.removeEventListener('keydown', this.keyHandler);
      this.removeEventListener('shopify:block:select', this.editorHandler);
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
